import * as React from "react";

function SvgInkit(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M16.066 20.802c2.566 0 4.646-2.113 4.646-4.72 0-2.607-2.08-4.72-4.646-4.72s-4.647 2.113-4.647 4.72c0 2.607 2.08 4.72 4.647 4.72z"
        fill="#131E2C"
      />
      <path
        d="M78.504 19.537a3.92 3.92 0 01-1.014-1.357 3.979 3.979 0 01-.353-1.664c0-1.602 1.367-3.02 1.367-3.02l3.29-3.83 3.276 3.83s1.367 1.418 1.367 3.02a3.988 3.988 0 01-.355 1.664 3.93 3.93 0 01-1.012 1.357 4.908 4.908 0 01-3.276 1.257 4.908 4.908 0 01-3.275-1.258h-.015z"
        fill="#5757F5"
      />
      <path
        d="M12.039 48.967V23.44h7.977v25.527h-7.977zM30.446 23.44v4.33a7.698 7.698 0 013.195-3.349 10.252 10.252 0 015.158-1.231c2.837 0 5.058.78 6.662 2.339 1.604 1.56 2.405 3.85 2.402 6.872v16.566h-7.97V33.759c0-1.512-.382-2.66-1.145-3.447-.767-.79-1.843-1.183-3.224-1.183a4.674 4.674 0 00-1.985.39 4.742 4.742 0 00-1.645 1.194c-.965 1.06-1.448 2.646-1.448 4.757v13.474h-7.973V23.44h7.973zm46.477 25.527h-9.23L58.85 36.432v12.535h-7.98V14.229h7.977v20.638l8.736-11.427h9.178l-9.613 12.232 9.775 13.295zm.873 0V23.44h7.974v25.527h-7.974zm21.846-20.141v11.727c-.024.387.039.774.186 1.132.147.358.374.676.662.93a3.329 3.329 0 002.211.707 7.47 7.47 0 003.88-1.007v6.09c-1.349.537-3.17.805-5.465.805-6.295 0-9.444-2.902-9.447-8.706V28.826h-3.98V23.44h3.98V17.4h7.974v6.04h6.444v5.386h-6.445z"
        fill="#131E2C"
      />
    </svg>
  );
}

export default React.forwardRef(SvgInkit);
